import NewsCard from './newsCard';

export default NewsCard;
